import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';

const captainDisabledRoutes = [
  'captain_assistants_index',
  'captain_assistants_responses_index',
  'captain_assistants_responses_pending',
  'captain_assistants_documents_index',
  'captain_tools_index',
  'captain_assistants_scenarios_index',
  'captain_assistants_playground_index',
  'captain_assistants_inboxes_index',
  'captain_assistants_settings_index',
  'captain_assistants_guardrails_index',
  'captain_assistants_guidelines_index',
  'captain_assistants_create_index',
].map(name => ({
  path: `captain-disabled/${name}`,
  name,
  redirect: to => ({
    name: 'inbox_view',
    params: { accountId: to.params.accountId },
  }),
}));

const settingsDisabledRoutes = [
  'attributes_list',
  'sla_wrapper',
  'sla_list',
].map(name => ({
  path: `settings-disabled/${name}`,
  name,
  redirect: to => ({
    name: 'general_settings_index',
    params: { accountId: to.params.accountId },
  }),
}));

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainDisabledRoutes,
        ...settingsDisabledRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
